export default __webpack_public_path__ + "781c0af15200e35f135c6bc99263c1f8.webp";